import { render, staticRenderFns } from "./PagoComplementario.vue?vue&type=template&id=2da5fdbb"
import script from "./PagoComplementario.vue?vue&type=script&lang=js"
export * from "./PagoComplementario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da5fdbb')) {
      api.createRecord('2da5fdbb', component.options)
    } else {
      api.reload('2da5fdbb', component.options)
    }
    module.hot.accept("./PagoComplementario.vue?vue&type=template&id=2da5fdbb", function () {
      api.rerender('2da5fdbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/PagoComplementario.vue"
export default component.exports